<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import AnnouncementApi from '../../api/AnnouncementApi'
import IssueApi from '../../api/IssueApi'
/** UI Components */
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import { Switch } from 'buefy/dist/components/switch'
import { Datepicker } from 'buefy/dist/components/datepicker'
import { Timepicker } from 'buefy/dist/components/timepicker'

// Basic Use - Covers most scenarios
import { VueEditor } from "vue2-editor"
import { customToolbar } from '../../constants/EditorToolbar'

export default {
    name : "AnnouncementsView",
    components: {
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-loading' : Loading,
        'b-modal' : Modal,
        'b-switch' : Switch,
        'b-datepicker' : Datepicker,
        'b-timepicker' : Timepicker,
        VueEditor
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        })
    },
    data(){
        return {
            globalLoading: null,
            posts: [],
            labelPosition : "on-border",
            newPost: {
                postTitle: '',
                postSubtitle: '',
                postBody: '',
                userId: null,
                datePosted: new Date()
            },
            activeAction: 'add',
            activePost: null,
            errorData: null,
            minDate : new Date(this.$moment(new Date()).subtract(1,'days')),
            customToolbar: customToolbar
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData", 
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getPosts();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        showLoading(){
            this.globalLoading = null
            this.globalLoading = this.$loading.open({
                container: null
            })
        },
        closeLoading(){
            if (this.globalLoading !== null) {
                this.globalLoading.close()
            }
            this.globalLoading = null
        },
        getPosts(activePost){
            this.showLoading()
            this.posts = [];
            AnnouncementApi.getAll(false)
            .then(response=>{
                this.closeLoading()
                let posts = response.data;
                if (response.data) {
                    if (!response.data.error) {
                        if (posts.length > 0) {
                            posts.forEach(post=>{
                                if (post.postBody) {
                                    // post.postBody.replace(/(?:\r\n|\r|\n)/g, '<br />');
                                    post.htmlMessage = post.postBody; 
                                    if (post.postBody.length > 25) {
                                        post.excerpt = post.postBody.substr(0,24)+'...'
                                    } else {
                                        post.excerpt = post.postBody
                                    }
                                }
                                /** Review dates after deployment */
                                // post.dateCreated = AppResourceUtil.convertDate(post.dateCreated)
                                // post.datePosted = AppResourceUtil.convertDate(post.datePosted)
                                // post.dateLastUpdated = AppResourceUtil.convertDate(post.dateLastUpdated)
                            })
                        }
                        this.posts = posts
                        if (activePost) {
                            var res = this.posts.filter(p => {
                                return p.postId === activePost.postId
                            })
                            if (res.length > 0) {
                                this.activePost = res[0]
                                this.viewPost(res[0])
                            }
                        }
                    }
                    else {
                        this.promptServerError({response},'Announcement.get');
                    }
                }
            })
            .catch(error=>{
                this.closeLoading()
                this.promptServerError(error,'Announcement.get');
            });
        },
        confirmDeletePost(post){
            if (!post) {
                return false;
            }
            // Confirm Action
            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This action will delete selected post from the database. What do you want to do?',
                cancelText: "Don't Delete",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.deletePost(post)
                }
            })
        },
        deletePost(post) {
            let ids = [post.postId];
            
            if (ids.length==0){
                this.$dialog.alert({
                    title: 'Error',
                    message: "<p>Unable to proceed. No data selected.</p>",
                    type: 'is-error'
                });
                return false;
            }

            AnnouncementApi.delete({
                postIds: ids
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            this.$notification.open({
                                duration: 5000,
                                message: 'Post deleted.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            // this.$eventHub.$emit('issues-updated',true);
                            this.getPosts(null);
                            this.activeAction = 'add'
                        }
                    }
                    else {
                        this.promptServerError({response},'Announcements.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Announcements.delete');
            });
        },
        submitPost() {
            this.clearError()

            if (!this.newPost.postBody || (this.newPost.postBody && this.newPost.postBody.trim().length === 0)) {
                this.showError('Fill out required fields.','Announcement body is required.')
                return false
            }

            var postData = Object.assign({},this.newPost)
            postData.userId = this.profile.userId
            postData.datePosted = this.$moment(postData.datePosted).format('YYYY-MM-DD HH:mm:ss')

            AnnouncementApi.add(postData)
            .then(response => {
                if (response) {
                    if (!response.data.error) {
                        var msg = 'posted successfully.'
                        if (postData.datePosted !== null) {
                            msg = 'will be posted on schedule date.'
                        }
                        this.$dialog.alert({
                            title: 'Success',
                            message: 'Announcement '+msg,
                            type: 'is-success'
                        });
                        this.reset()
                        this.getPosts()
                    }
                    else {
                        this.promptServerError({response},'Announcements.add');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Announcements.add');
            });
            
        },
        clearError () {
            this.errorData = null;
        },
        closeError () {
            this.clearError()
        },
        showError(title,msg) {
            this.errorData = {}
            this.errorData.title = title
            this.errorData.message = msg
        },
        checkPostDate (date){
            if (!date) {
                return false
            }
            let d = date;
            var now = new Date()
            d.setHours(now.getHours())
            d.setMinutes(now.getMinutes())
            d.setSeconds(now.getSeconds())
            date = d
        },
        reset() {
            this.clearError()
            this.newPost = {
                postTitle: '',
                postSubtitle: '',
                postBody: '',
                userId: null,
                datePosted: new Date()
            }
        },
        viewPost(post) {
            this.activePost = post
            this.activeAction = 'view'
        },
        editPost(post) {
            this.activeAction = 'edit'
            var archived = true
            if (this.activePost.isArchived === 0) {
                archived = false
            }

            // var d = new Date(this.activePost.datePosted)

            this.activePost.temp = {
                postId: this.activePost.postId,
                postTitle: this.activePost.postTitle,
                postSubtitle: this.activePost.postSubtitle,
                postBody: this.activePost.postBody,
                datePosted: new Date(this.activePost.datePosted),
                datePostedStr: this.$moment(this.activePost.datePosted,'YYYY-MM-DD'),
                isArchived: archived,
                userId: this.profile.userId
            }
        },
        closeView() {
            this.activeAction = 'add'
            this.activePost = null 
            this.reset()
        },
        savePost() {
            this.clearError()

            var newData = Object.assign({},this.activePost.temp)

            if (!newData.postBody || (newData.postBody && newData.postBody.trim().length === 0)) {
                this.showError('Fill out required fields.','Announcement is required.')
                return false
            }

            if (newData.datePosted !== this.activePost.datePosted) {
                newData.newDatePosted = this.$moment(newData.datePosted).format('YYYY-MM-DD HH:mm:ss');
            }

            if (newData.isArchived === true) {
                newData.archived = 1
            } else {
                newData.archived = 0
            }

            AnnouncementApi.save(newData)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isUpdated) {
                            this.$notification.open({
                                duration: 5000,
                                message: 'Changes saved.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            // this.$eventHub.$emit('issues-updated',true);
                            this.getPosts(this.activePost);
                        }
                    }
                    else {
                        this.promptServerError({response},'Announcements.save');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Announcements.save');
            });
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Announcements ({{posts.length}})</p>

        <div>
        </div>
        
        <section class="section no-padd--top"> 
            <section class="section no-padd app-view app-view--admin">

                <div class="columns">
                    <!-- List -->
                    <div class="column is-3"
                                style="padding-top:1rem">
                        <div v-if="posts.length > 0"
                            style="max-height:65vh;overflow-y:scroll">
                            <ul style="margin-top:0.5rem">
                                <li v-for="post in posts"
                                    v-bind:key="post.postId"
                                    @click="viewPost(post)"
                                    class="litem-post box">
                                    <div class="content">
                                        <small class="has-text-grey caption"
                                            v-if="post.postStatus=== 'Active'">Date posted: {{post.datePosted}} by {{post.postedByName}}</small>
                                        <div>
                                            <span class="tag is-dark is-small" 
                                                v-if="post.postStatus=== 'Scheduled' && post.isArchived==0">Scheduled</span>
                                            <span v-if="post.isArchived===1" class="tag is-light is-small is-italic has-text-grey">Archived</span> 
                                            <div 
                                                v-html="post.excerpt"></div>
                                        </div>
                                    </div>
                                    <div
                                    style="text-align:right;margin-top:0.4rem;">
                                        <a class="button is-link is-small"
                                            v-on:click="viewPost(post)"
                                            align="right">
                                            View Post
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <span>No data found.</span>
                        </div>
                    </div>

                    <div class="separator-v"></div>

                    <!-- Form section -->
                    <div class="column"
                                style="padding-top:1rem">

                        <!-- Add Post Form -->
                        <div v-if="activeAction !== 'view'"> 
                            <div v-if="activeAction == 'add'"
                                class="box">
                                <p class="title is-4">Create New Announcement</p>
                                
                                <div class="notification is-danger"
                                    v-if="errorData!=null">
                                    <button class="delete"
                                        type="button"
                                        v-on:click="closeError"></button>
                                    <strong>Error: {{errorData.title}}</strong>
                                    <p>{{errorData.message}}</p>
                                </div>

                                <!-- <b-field >
                                    <b-input
                                        placeholder="Heading"
                                        v-model="newPost.postTitle" 
                                        value=""
                                        maxlength="30"></b-input>
                                </b-field>

                                <b-field >
                                    <b-input
                                        placeholder="Subheading"
                                        v-model="newPost.postSubtitle" 
                                        value=""
                                        maxlength="30"></b-input>
                                </b-field> -->

                                <b-field >
                                    <!-- <b-input
                                        placeholder="*Announcement"
                                        type="textarea"
                                        v-model="newPost.postBody"
                                        maxlength="400"
                                        required>
                                    </b-input> -->
                                    <vue-editor
                                        id="create-editor"
                                        v-model="newPost.postBody"
                                        :editor-toolbar="customToolbar"></vue-editor>
                                </b-field>

                                

                                <b-field
                                    label="Schedule Post">
                                    <b-datepicker
                                        v-bind:show-week-number="true"
                                        v-model="newPost.datePosted"
                                        :min-date="minDate"
                                        @input="checkPostDate(newPost.datePosted)"
                                        icon="calendar-today">
                                    </b-datepicker>
                                </b-field>

                                <p class="control">
                                    <span class="has-text-grey caption">*Change date to schedule when to post the announcement. Otherwise, leave this as is to post upon submission.</span>
                                </p> <br/>

                                <b-field >
                                    <div class="buttons">
                                        <a class="button is-success"
                                            v-on:click="submitPost">
                                            Submit
                                        </a>
                                        <a class="button is-link"
                                            v-on:click="reset">
                                            Reset Form
                                        </a>
                                    </div>
                                </b-field>
                            </div>
                            <div v-if="activeAction == 'edit'"
                                class="box">
                                <p class="title is-4">Edit Announcement</p>
                                
                                <div class="notification is-danger"
                                    v-if="errorData!=null">
                                    <button class="delete"
                                        type="button"
                                        v-on:click="closeError"></button>
                                    <strong>Error: {{errorData.title}}</strong>
                                    <p>{{errorData.message}}</p>
                                </div>

                                <!-- <b-field >
                                    <b-input
                                        placeholder="Heading"
                                        v-model="newPost.postTitle" 
                                        value=""
                                        maxlength="30"></b-input>
                                </b-field>

                                <b-field >
                                    <b-input
                                        placeholder="Subheading"
                                        v-model="newPost.postSubtitle" 
                                        value=""
                                        maxlength="30"></b-input>
                                </b-field> -->

                                <b-field >
                                    <!-- <b-input
                                        placeholder="*Announcement"
                                        type="textarea"
                                        v-model="activePost.temp.postBody"
                                        maxlength="400"
                                        required>
                                    </b-input> -->

                                    <vue-editor
                                        id="edit-editor"
                                        v-model="activePost.temp.postBody"
                                        :editor-toolbar="customToolbar"></vue-editor>
                                </b-field>

                                <b-field
                                    label="Date Posted (*To move/schedule posting, select a date.)">
                                    <b-datepicker
                                        v-bind:show-week-number="true"
                                        v-model="activePost.temp.datePosted"
                                        :min-date="minDate"
                                        @input="checkPostDate(activePost.temp.datePosted)"
                                        icon="calendar-today">
                                    </b-datepicker>
                                </b-field>
                                <br />
                                <b-field label="Switch this ON to archive post.">
                                    <b-switch v-model="activePost.temp.isArchived">
                                        Archived
                                    </b-switch>
                                </b-field><br />

                                <b-field >
                                    <div class="buttons">
                                        <a class="button is-success"
                                            v-on:click="savePost">
                                            Save Changes
                                        </a>
                                        <a class="button is-link"
                                            v-on:click="viewPost(activePost)">
                                            Close Form
                                        </a>
                                    </div>
                                </b-field>
                            </div>
                        </div>

                        <!-- View Post -->
                        <div v-if="activePost && activeAction == 'view'"
                            class="box"> 
                            <p class="title is-4">View Announcement (Post ID: {{activePost.postId}})</p>

                            <p class="has-text-grey caption"
                                v-if="activePost.postStatus=== 'Active'">Date Posted: {{activePost.datePosted}} by {{activePost.postedByName}}</p>

                            <!-- <div class="separator-h"></div> -->
                            
                            <div class="content">
                                <div v-html="activePost.htmlMessage"></div>
                            </div>

                            <div v-if="activePost.postStatus=== 'Scheduled'"
                                style="margin-top:0.3rem;">
                                <div class="tags has-addons">
                                    <span class="tag is-dark is-small">Scheduled</span>
                                    <span class="tag is-info is-small">{{activePost.datePosted}}</span>
                                </div>
                            </div>

                            <div class="separator-h"></div>
                            <b-field >
                                <div class="buttons">
                                    <a class="button is-danger is-inverted"
                                        v-on:click="confirmDeletePost(activePost)">
                                        Delete
                                    </a>
                                    <a class="button is-info"
                                        v-on:click="editPost(activePost)">
                                        Edit
                                    </a>
                                    <a class="button is-light"
                                        v-on:click="closeView">
                                        Close
                                    </a>
                                </div>
                            </b-field>
                        </div>
                    </div>
                </div>
                
            </section>
            
        </section>  

        
    </section>
</template>

<style lang="scss" scoped>
.separator-h {
    display:block;
    height:2px;
    width: 99%;
    margin:auto;
    margin-top: 1rem;
    margin-bottom: 0.7rem;
    border:none;
    border-bottom: 1px solid rgb(224, 224, 224);
}
.caption {
    font-size: 12px;
}
.litem-post {
    border-bottom: 1px solid rgb(224, 224, 224);
    padding-bottom: 0.5rem;
    margin: 0 0.4rem 0.4rem 0.8rem;
}
.litem-post:last-child {
    border-bottom: none;
}
.bold {
    font-weight: 700;
}
.separator-v {
    /* display: block; */
    width:1px;
    height: 100vh;
    margin:auto;
    border:none;
    border-left: 1px solid rgb(224, 224, 224);
}
.announcement-holder {
    border: 1px solid blue;
}
.announcement-h2 {
    font-size: 1.5em !important;
    font-weight: bold !important;
}
.announcement-holder div > ul,
.announcement-holder div > ol {
    all: unset !important;
}
.announcement-holder div > ul {
    list-style: disc;
    border:1px solid red;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/AnnouncementsView.vue